<template>
  <div class="ship-manage tb">
    <custom-tab
      :list="tabData"
      v-model="tabIndex"
    ></custom-tab>
    <pending v-if="tabIndex === 0"></pending>
    <shipped v-if="tabIndex === 1"></shipped>
  </div>
</template>

<script>
import pending from './children/pending.vue';
import shipped from './children/shipped.vue';

export default {
  name: 'ship',
  mixins: [],
  components: {
    pending,
    shipped
  },
  props: {},
  data() {
    return {
      tabIndex: null,
    };
  },
  computed: {
    tabData() {
      const arr = [];
      const pendingTab = {
        name: this.$t('crm_ship.dai_fa_huo'),
        value: 0,
      };
      const shippedTab = {
        name: this.$t('crm_ship.yi_fa_huo'),
        value: 1,
      };
      if (this.funcView.contract_ship_pending_list) {
        arr.push(pendingTab);
      }
      if (this.funcView.contract_ship_shipped_list) {
        arr.push(shippedTab);
      }
      return arr;
    }
  },
  watch: {
    tabData: {
      immediate: true,
      handler(val) {
        if (val && val.length && !this.tabIndex) {
          this.tabIndex = val[0].value;
        }
      },
    },
  },

  methods: {

  },
  created() {},
  mounted() {
    this.getFuncView();


  },
};
</script>

<style lang="scss" >
.ship-manage {
  padding-left: 0 !important;

  .num-info{
    float: left;
    overflow: hidden;
    .item{
      font-size: 12px;
      color: #606266;
    .sum {
        color:#0d9ae0;
      }
    }
  }
}
</style>
